import { useState } from "react";
import { useAuth } from "./AuthProvider";

export function SignInButton({
  className = "button ghost small",
  label = "Sign in with Google",
  onSignedIn,
  onSignedOut,
}: {
  className?: string;
  label?: string;
  onSignedIn?: () => void;
  onSignedOut?: () => void;
}) {
  const { auth, user, signIn, signOut, ready } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  if (!ready || (!auth.google_enabled && auth.mode === "off")) return null;

  if (user) {
    return (
      <button
        type="button"
        className={className}
        disabled={busy}
        onClick={async () => {
          setBusy(true);
          setError("");
          try {
            await signOut();
            onSignedOut?.();
          } catch (err) {
            setError(err instanceof Error ? err.message : "Sign out failed");
          } finally {
            setBusy(false);
          }
        }}
      >
        Sign out
      </button>
    );
  }

  if (!auth.google_enabled) return null;

  return (
    <>
      <button
        type="button"
        className={className}
        disabled={busy}
        onClick={async () => {
          setBusy(true);
          setError("");
          try {
            await signIn();
            onSignedIn?.();
          } catch (err) {
            setError(err instanceof Error ? err.message : "Sign in failed");
          } finally {
            setBusy(false);
          }
        }}
      >
        {busy ? "Signing in…" : label}
      </button>
      {error ? (
        <span className="subtle" role="alert">
          {error}
        </span>
      ) : null}
    </>
  );
}
